export const FETCH_REPORT_AMOUNT_INCREMENT = 50;
export const FETCH_REPORT_FROM_OPERATION_ID = 0;
export const FETCH_REPORT_UNTIL_OPERATION_ID = 2147483647;
